import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=52441cba&scoped=true&"
import script from "./Tenants.vue?vue&type=script&lang=ts&"
export * from "./Tenants.vue?vue&type=script&lang=ts&"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=52441cba&prod&scoped=true&lang=css&"
import style1 from "./Tenants.vue?vue&type=style&index=1&id=52441cba&prod&scoped=true&lang=css&"
import style2 from "./Tenants.vue?vue&type=style&index=2&id=52441cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52441cba",
  null
  
)

export default component.exports